// fileTypeConfig.js

export const FILE_TYPE_GROUPS = {
  images: {
    label: "Images",
    patterns: ["image/*"],
  },
  documents: {
    label: "Documents",
    patterns: [
      // PDF
      "application/pdf",

      // Word
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",

      // Excel + CSV
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/csv",

      // PowerPoint
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",

      // Text
      "text/plain",

      // XML
      "application/xml",
      "text/xml",

      // RTF
      "application/rtf",

      // OpenDocument
      "application/vnd.oasis.opendocument.text",
      "application/vnd.oasis.opendocument.spreadsheet",
      "application/vnd.oasis.opendocument.presentation",
    ],
  },
  videos: {
    label: "Videos",
    patterns: ["video/*"],
  },
  audio: {
    label: "Audio",
    patterns: ["audio/*"],
  },
};

// Central MIME → extension mapping
export const MIME_TO_EXT = {
  "application/pdf": ["pdf"],

  "application/msword": ["doc"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    "docx",
  ],

  "application/vnd.ms-excel": ["xls"],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": ["xlsx"],
  "text/csv": ["csv"],

  "application/vnd.ms-powerpoint": ["ppt"],
  "application/vnd.openxmlformats-officedocument.presentationml.presentation": [
    "pptx",
  ],

  "text/plain": ["txt"],

  "application/xml": ["xml"],
  "text/xml": ["xml"],

  "application/rtf": ["rtf"],

  "application/vnd.oasis.opendocument.text": ["odt"],
  "application/vnd.oasis.opendocument.spreadsheet": ["ods"],
  "application/vnd.oasis.opendocument.presentation": ["odp"],
};
